import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store'
import routeEvents from '@/lib/route-events'
import Home from '@/pages/Home'
import PageNotFound from '@/pages/PageNotFound'
import Login from '@/pages/Login'
import About from '@/pages/About'
import Contact from '@/pages/Contact'
import Single from '@/pages/Single'
import Page from '@/pages/Page'
import Post from '@/pages/Post'
import Archive from '@/pages/Archive'
import Search from '@/pages/Search'
// import Program from '@/pages/Program'
import Release from '@/pages/Release'
// import PreviewProgram from '@/pages/PreviewProgram'
import PreviewRelease from '@/pages/PreviewRelease'
import Members from '@/pages/Members'
import MemberConfirm from '@/pages/MemberConfirm'
import Upload from '@/pages/Upload'
import Shop from '@/pages/Shop'
import Admin from '@/pages/Admin'

Vue.use( VueRouter )

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home,
    beforeEnter: routeEvents.toPath,
    meta: {
      classes: [ 'home' ],
    },
  },
  {
    path: '/login/:then(.+)?',
    name: 'login',
    component: Login,
    props: true,
    meta: {
      classes: [ 'login' ],
    },
  },
  { path: '/about-us/:path(.+)?', name: 'about', component: About, props: true },
  {
    path: '/contact-us/:path(.+)?',
    component: Contact,
    name: 'contact',
    props: true,
    meta: {
      classes: [ 'contact' ],
    },
  },
  {
    path: '/preview/:program/:release',
    name: 'preview-release',
    component: PreviewRelease,
    beforeEnter: routeEvents.toPreviewRelease,
    meta: {
      classes: [ 'preview' ],
    },
  },
  {
    path: '/preview/:path',
    name: 'preview',
    component: PreviewRelease,
    beforeEnter: routeEvents.toPreview,
    meta: {
      classes: [ 'preview' ],
    },
  },
  {
    path: '/page/:path',
    name: 'page',
    component: Page,
    beforeEnter: routeEvents.toPath,
    meta: {
      classes: [ 'page' ],
    },
  },
  {
    path: '/post/:path',
    name: 'post',
    component: Post,
    beforeEnter: routeEvents.toPath,
    meta: {
      classes: [ 'post' ],
    },
  },
  {
    path: '/category/:category',
    name: 'category',
    component: Archive,
    props: true,
    meta: {
      classes: [ 'cateogry' ],
    },
  },
  {
    path: '/tag/:tag',
    name: 'tag',
    component: Archive,
    props: true,
    meta: {
      classes: [ 'tag' ],
    },
  },
  {
    path: '/blog/',
    name: 'blog',
    component: Archive,
    meta: {
      classes: [ 'blog' ],
    },
  },
  {
    path: '/search/',
    name: 'search',
    component: Search,
    meta: {
      classes: [ 'page' ],
    },
  },
  {
    path: '/shop/',
    name: 'shop',
    component: Shop,
    meta: {
      classes: [ 'shop' ],
    },
  },
  {
    path: '/members/checkout',
    name: 'members-checkout',
    component: Members,
    meta: {
      auth: true,
      classes: [ 'members', 'checkout' ],
    },
  },
  {
    path: '/members/confirmation',
    name: 'members-confirm',
    component: MemberConfirm,
    meta: {
      auth: true,
      classes: [ 'members', 'confirmation' ],
    },
  },
  {
    path: '/members/',
    name: 'members',
    component: Members,
    meta: {
      auth: true,
      classes: [ 'members' ],
    },
  },
  {
    path: '/upload/',
    name: 'upload',
    component: Upload,
    meta: {
      auth: true,
      classes: [ 'upload' ],
    },
  },
  {
    path: '/admin',
    name: 'admin',
    component: Admin,
    beforeEnter: routeEvents.toAdminPath,
    meta: {
      layout: 'admin',
      auth: 'administer_site',
      classes: [ 'admin' ],
    },
  },
  {
    path: '/admin/:path',
    name: 'admin-page',
    component: Admin,
    beforeEnter: routeEvents.toAdminPath,
    props: true,
    meta: {
      layout: 'admin',
      auth: 'administer_site',
      noScroll: true,
      classes: [ 'admin', 'page' ],
    },
  },
  {
    path: '/admin/:path/:section',
    name: 'admin-section',
    component: Admin,
    beforeEnter: routeEvents.toAdminPath,
    props: true,
    meta: {
      layout: 'admin',
      auth: 'administer_site',
      noScroll: true,
      classes: [ 'admin', 'section' ],
    },
  },
  {
    path: '/admin/:path/:section/:item',
    name: 'admin-item',
    component: Admin,
    beforeEnter: routeEvents.toAdminPath,
    props: true,
    meta: {
      layout: 'admin',
      auth: 'administer_site',
      noScroll: true,
      classes: [ 'admin', 'section-item' ],
    },
  },
  {
    path: '/oops',
    name: 'not-found',
    component: PageNotFound,
    props: route => route.query,
    beforeEnter: ( to, from, next ) => {
      next()
      store.dispatch( 'stopLoading', 'page' )
      store.dispatch( 'stopLoading', 'admin-page' )
    },
    meta: {
      classes: [ 'not-found' ],
    },
  },
  {
    path: '/:program/:release',
    name: 'release',
    component: Release,
    beforeEnter: routeEvents.toRelease,
    meta: {
      classes: [ 'release' ],
    },
  },
  {
    path: '/:path',
    name: 'single',
    component: Single,
    beforeEnter: routeEvents.toPath,
    meta: {
      classes: [ 'single' ],
    },
  },
  {
    path: '*',
    name: '404',
    redirect: to => ({
      name: 'not-found',
      query: { ...to.query, q: to.path }
    }),
    meta: {
      classes: [ 'not-found' ],
    },
  }
]

const router = new VueRouter({
  mode: 'history',
  // base: process.env.BASE_URL,
  routes
})

// global guard, manage redirection based on authentication and payment
// fetch post first so we can decide some more specific routing
router.beforeEach(( to, from, next ) => {
  if ( /^\/?admin/.test( from.name ) && /^\/?admin/.test( to.name )) {
    store.dispatch( 'startLoading', 'admin-page' )
  } else {
    store.dispatch( 'startLoading', 'page' )
  }
  store.dispatch( 'closeModal' )
  store.dispatch( 'closeSidebar' )
  store.dispatch( store.state.menu ? 'setMenuPath' : 'getMenu', to.path )
  if ( to.meta.auth && !store.state.user ) {
    next({ path: '/login' + to.path, query: to.query })
  } else {
    next()
  }
})

router.afterEach(( to, from, next ) => {
  setTimeout(() => {
    store.dispatch( 'stopLoading', 'page' )
    store.dispatch( 'stopLoading', 'admin-page' )
    store.dispatch( 'setLayout', to.meta.layout )
  }, 10000 )
  // give pages ten seconds to resolve loading on their own, then step in
})

export default router
